module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargador-dd-43992ace.png";